import { render, staticRenderFns } from "./cp-content-activity-card.vue?vue&type=template&id=5b554a60&scoped=true"
import script from "./cp-content-activity-card.ts?vue&type=script&lang=ts&external"
export * from "./cp-content-activity-card.ts?vue&type=script&lang=ts&external"
import style0 from "./cp-content-activity-card.scss?vue&type=style&index=0&id=5b554a60&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b554a60",
  null
  
)

export default component.exports